import axios from 'axios';

// Dynamically determine API base URL
const isLocalXampp = window.location.pathname.startsWith('/shutterservices');
const baseURL = isLocalXampp ? '/shutterservices/api/v1' : '/api/v1';

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

// Response interceptor: automatically detect session expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Do not dispatch on public login, registration, me, or ping check requests
      const requestUrl = error.config?.url || '';
      const isPublicAuthCheck = ['/auth/login', '/auth/register', '/auth/me', '/auth/ping', '/auth/user', '/leads'].some((p) => requestUrl.includes(p));
      if (!isPublicAuthCheck) {
        window.dispatchEvent(new CustomEvent('auth:session_expired'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
